import React, { useCallback } from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import { themeGet } from '@styled-system/theme-get';
import { maxCount } from '../utils/tabsHelpers';

const Container = styled.div`
  cursor: pointer;
  margin-left: 0;
  height: 42px;
  padding: 0 10px;
  text-align: center;
  display: inline-block;
  font-weight: 400;
  color: ${themeGet('colors.black.80')};

  ${({ isActive }) =>
    isActive &&
    css`
      color: ${themeGet('colors.primary.100')};
      border-bottom: solid 2px ${themeGet('colors.primary.100')};
    `}
`;

const Arrow = styled.i`
  width: 6px;
  height: 12px;
  margin: 0px 9px;
`;

Arrow.defaultProps = {
  className: 'fa-regular fa-chevron-right fa-xs'
};

const Title = styled.span`
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.1px;
`;

const Circle = styled.div`
  display: inline-flex;
  padding: 2px 9px;
  border-radius: 15px;
  align-items: center;
  justify-content: space-around;
  border: solid 1px;
  background: ${themeGet('colors.black.80')};
  color: white;
  margin-left: 4px;

  ${({ isActive }) =>
    isActive &&
    css`
      background: ${themeGet('colors.primary.100')};
    `}
`;

const CircleText = styled.span`
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.2px;
`;

export const Tab = ({
  selectStatus,
  statusNav,
  activeStatus,
  statuses,
  tiles,
}) => {
  const onClick = useCallback(() => {
    selectStatus(statusNav);
  }, [selectStatus, statusNav]);
  const isActive = statusNav === activeStatus;
  const tilesAmount =
    statusNav === 'share'
      ? maxCount(tiles.draft.count)
      : maxCount(tiles[statusNav].count);

  return (
    <li onClick={onClick} id={`${statuses[statusNav].uiDisplay.toLowerCase()}`}>
      <Container isActive={isActive}>
        <Title>{`${statuses[statusNav].uiDisplay}`}</Title>
        <Circle isActive={isActive}>
          <CircleText>{tilesAmount}</CircleText>
        </Circle>
      </Container>
      <Arrow />
    </li>
  );
};

Tab.propTypes = {
  selectStatus: PropTypes.func,
  statusNav: PropTypes.string,
  activeStatus: PropTypes.string,
  statuses: PropTypes.object,
  tiles: PropTypes.shape({
    draft: PropTypes.object,
  }),
};
